
class PaymentFeeTemplateCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;

    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
    }

    set item(item:PaymentFeeTemplate){
        this.nameLabel.text = item.name;
    }
}

class PaymentFeeTemplateListViewController extends MUIViewController
{
    static newInstance() : PaymentFeeTemplateListViewController {
        let vc = new PaymentFeeTemplateListViewController("payment-fee-template-list-view");
        vc.initWithResource("layout/payment_fee_templates/PaymentFeeTemplateListView.html");
        return vc;
    }

    private addButton:MUIButton = null;
    private tableView:UITableView = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.setAction(this, this.addTemplate);

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false) return;

        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    numberOfSections(tableview:UITableView){
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableview:UITableView, section:number){
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        let cell = tableview.dequeueReusableCellWithIdentifier("PaymentFeeTemplateCell") as PaymentFeeTemplateCell;

        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as PaymentFeeTemplate;
        cell.item = item;

        return cell;
    }

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as PaymentFeeTemplate;

        let vc = PaymentFeeTemplateDetailViewController.newInstance();
        vc.item = item;

        this.navigationController.pushViewController(vc, true);
    }

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView:UITableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as PaymentFeeTemplate;

        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            this.deleteTemplate(item);
        }
    }

    // The BusinessLicense -> template relationship has no inverse, so deleting the
    // template does not nullify the licenses pointing at it: unlink them explicitly.
    // Their fee rows are kept, so they just become custom.
    private deleteTemplate(template:PaymentFeeTemplate){
        let predicate = MIOPredicate.predicateWithFormat('paymentFeeTemplate.identifier == "' + template.identifier + '" and deletedAt == null');
        DBHelper.queryObjectsWithCompletion("BusinessLicense", null, predicate, [], this, function(this:PaymentFeeTemplateListViewController, licenses:BusinessLicense[]){
            if (licenses.length == 0) {
                DBHelper.deleteObjectFromMainContext(template, true);
                return;
            }

            let avc = new MUIAlertViewController();
            avc.initWithTitle(MIOLocalizeString("WARNING", "WARNING"), licenses.length + " " + MIOLocalizeString("LICENSES_USE_THIS_TEMPLATE_FEES_KEPT_AS_CUSTOM", "LICENSES USE THIS TEMPLATE. THEIR CURRENT FEES WILL BE KEPT AS CUSTOM."), MUIAlertViewStyle.Default);

            avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("DELETE", "DELETE"), MUIAlertActionStyle.Destructive, this, function(this:PaymentFeeTemplateListViewController){
                for (let license of licenses) license.paymentFeeTemplate = null;
                DBHelper.deleteObjectFromMainContext(template, true);
            }));

            avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

            this.presentViewController(avc, true);
        });
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;

        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;

        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("name", true)];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("PaymentFeeTemplate", sortDescriptors, null);

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;

        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller:MIOFetchedResultsController){
        this.tableView.reloadData();
    }

    private addTemplate(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("NEW_PAYMENT_FEE_TEMPLATE", "NEW PAYMENT FEE TEMPLATE"), MIOLocalizeString("NAME", "NAME"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("NAME", "NAME"));
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("ADD", "ADD"), MUIAlertActionStyle.Default, this, function(this:PaymentFeeTemplateListViewController){
            let name = avc.textFields[0].text.trim();
            if (name.length == 0) return;

            this.createTemplate(name);
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }

    private createTemplate(name:string){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        let template = MIOEntityDescription.insertNewObjectForEntityForName("PaymentFeeTemplate", ad.managedObjectContext) as PaymentFeeTemplate;
        template.name = name;

        ad.managedObjectContext.save();

        let vc = PaymentFeeTemplateDetailViewController.newInstance();
        vc.item = template;
        this.navigationController.pushViewController(vc, true);
    }
}
